import React, { useContext } from 'react'
import { Text, Box, Select } from '@chakra-ui/react'
import { Formik, Form, Field } from 'formik'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import * as Yup from 'yup'

import { WorkflowsContext } from '@context'
import { Loading } from '@components'
import { EditDrawerFooter } from '../../../edit-drawer/edit-drawer-footer'
import { endpoints } from '@api'

type RouteParams = {
  workflowId: string
  organizationId: string
}

type Props = {
  closeDrawer: () => void
  onSubmit: (trigger: Trigger) => void
}

type Trigger = {
  workflowId: string
  triggerType: string
  config: TriggerConfig | {}
}

type TriggerConfig = {
  programId: string
}

type Program = {
  id: string
  name: string
}

const schema = Yup.object().shape({
  programId: Yup.string().required()
})

export const ProgramStartedTrigger = ({ closeDrawer, onSubmit }: Props) => {
  const { selectedNode } = useContext(WorkflowsContext)
  const { organizationId, workflowId } = useParams<RouteParams>()
  const config = selectedNode?.config

  const initialValues = {
    programId: config?.programId || ''
  }

  const { data, isLoading } = useQuery(
    [endpoints.getPrograms.getCacheId(), organizationId],
    () =>
      endpoints.getPrograms.request({
        organizationId
      })
  )

  const allPrograms = data?.programs || []

  if (isLoading) return <Loading />

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={values => {
        const trigger: Trigger = {
          workflowId,
          triggerType: 'program-started-trigger',
          config: { programId: values.programId }
        }
        onSubmit(trigger)
      }}
    >
      {({ values, errors, resetForm: resetFields }) => {
        const resetForm = (updates: any) => {
          const updatedValues = { ...initialValues, ...updates }
          resetFields({ values: updatedValues })
        }

        return (
          <Form>
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mb="medium"
              >
                <Text>Program is</Text>
                <Field name="programId">
                  {({ field }: { field: { value: string } }) => (
                    <Select
                      {...field}
                      value={field.value}
                      borderColor={errors?.programId ? 'error' : 'light_gray'}
                      color={field.value ? 'black' : 'gray'}
                      w="360px"
                      onChange={e => {
                        resetForm({ programId: e.target.value })
                      }}
                    >
                      <option value="" disabled>
                        Choose a program
                      </option>
                      {allPrograms?.map((program: Program) => (
                        <option key={program.id} value={program.id}>
                          {program.name}
                        </option>
                      ))}
                    </Select>
                  )}
                </Field>
              </Box>
            </Box>
            <EditDrawerFooter onCancel={closeDrawer} hideDelete />
          </Form>
        )
      }}
    </Formik>
  )
}
